function getStatus(statusObject) {
    return statusObject.buyable
        ? 'inStock'
        : statusObject.stockNotificationEnabled
            ? 'notifyWhenBack'
            : 'outOfStock';
}
export function useStockStatus(product) {
    const stockStatus = product === null || product === void 0 ? void 0 : product.stockStatus;
    if (!stockStatus) {
        console.warn('The provided product does not have a stockStatus');
        return {
            status: null,
            text: null,
            maxOrderQuantity: null,
            stockDate: null
        };
    }
    return {
        status: getStatus(stockStatus),
        text: stockStatus.text || null,
        maxOrderQuantity: stockStatus.maxOrderQuantity,
        stockDate: stockStatus.stockDate
    };
}
//# sourceMappingURL=useStockStatus.js.map